import React, { Fragment } from 'react';

import AuthService from '../../shared/services/AuthService';
import Box from '@mui/material/Box';
import CertificateCard from './CertificateCard';
import { CustomLoadingProgress } from '../../shared/components/CustomLoadingProgress';
import ErrorPanel from '../../shared/components/ErrorPanel';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import UserProfilePanel from './UserProfilePanel';
import styles from '../styles/CertificateCard.module.css';
import { useCertificates } from '../hooks/useCertificates';

export default function UserProgress() {
  const { loading, error, userCertificates } = useCertificates(
    AuthService.Userkey
  );

  const courses = userCertificates?.courses || [];
  const lessons = userCertificates?.lessons || [];

  return (
    <>
      <Box marginBottom={2} marginLeft={1} marginRight={1}>
        <UserProfilePanel />
      </Box>
      <Box m={1}>
        <Grid style={{ flex: 1 }}>
          <Typography variant="h6">My Certificates</Typography>
        </Grid>

        <Grid
          direction={'column'}
          container
          justifyContent="center"
          spacing={1}
        >
          {loading ? (
            <CustomLoadingProgress />
          ) : error ? (
            <ErrorPanel title="Failed to load certificates" />
          ) : courses.length > 0 ? (
            courses.map((course, index) => (
              <Fragment key={`${course.coursekey}-${index}`}>
                <Grid>
                  <Typography
                    variant="body2"
                    className={styles.typography}
                  >{`COURSE: ${course.courseTitle}`}</Typography>
                </Grid>
                <Grid>
                  <Grid container direction="column" justifyContent="center">
                    {lessons
                      .filter((lesson) => lesson.coursekey === course.coursekey)
                      .map((lesson) => (
                        <CertificateCard
                          key={lesson.lessonkey}
                          title={lesson.lessonTitle}
                          isLesson
                          completed={lesson.completed}
                          certStatus={lesson.certStatus}
                          lessonOrCoursekey={lesson.lessonkey}
                        />
                      ))}
                    {course.assets && (
                      <CertificateCard
                        title={course.courseTitle}
                        completed={course.completed}
                        certStatus={course.certStatus}
                        lessonOrCoursekey={course.coursekey}
                      />
                    )}
                  </Grid>
                </Grid>
              </Fragment>
            ))
          ) : (
            <Grid>
              <Typography variant="body1">
                There are no certificates achieved yet.
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
}
